import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const LogoutIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="-1 1 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        stroke={iconColor}
        strokeWidth={1.5}
        d="M20 12.5L16 16.8333M20 12.5L16 8.5M20 12.5L7.33333 12.5M12.6667 20.5H4L4 4.5L12.6667 4.5"
        strokeLinejoin="round"
      />
    </Box>
  );
};
